module.exports = __webpack_public_path__ + "img/Avatar.6ce24df7.svg";